import { render, staticRenderFns } from "./metadataTypeOverView.vue?vue&type=template&id=37f821ac&"
import script from "./metadataTypeOverView.vue?vue&type=script&lang=js&"
export * from "./metadataTypeOverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports